<template>
    <!-- Template code goes here. Remember that a template always has to have 1 main wrapper, that is why we start with an empty div. -->
    <div class="friendly-popup-bg">
        <div class="friendly-popup-wrapper">
            <div class="popup-top">
                <h3 class="normal-text">How do you like your cookies?</h3>
                <p class="light-text small-text">We use cookies to make your experience <b>awesome.</b> That's basically all you need to know, but we still want to give you the option to choose.</p>
            </div>
            <div class="popup-content">
                <div @click="togglePopup" class="popup-button  gray-button">
                    <i class="far fa-frown"></i>
                    <h4>Frozen</h4>
                    <p>It's a cookie, but that's about it.</p>
                    <div class="info-box">
                        <p class="light-text">You allow the use of <b class="secondary-c">functional</b> cookies, which are required to make the website run.</p>
                    </div>
                </div>
                <div @click="togglePopup" class="popup-button  orange-button">
                    <i class="far fa-meh"></i>
                    <h4>Grocery store</h4>
                    <p>It's good, but you don't mind sharing it.</p>
                    <div class="info-box">
                        <p class="light-text">You allow the use of <b class="secondary-c">functional</b> and <b class="secondary-c">tracking</b> cookies so we can improve your experience by analyzing user behavior.</p>
                    </div>
                </div>
                <div @click="togglePopup" class="popup-button  green-button">
                    <span></span>
                    <i class="far fa-smile"></i>
                    <h4>Home baked</h4>
                    <p>How your grandma meant it to be.</p>
                    <div class="info-box">
                        <p class="light-text">You allow the use of <b class="secondary-c">functional</b>, <b class="secondary-c">tracking</b> and <b class="secondary-c">marketing</b> cookies so we can offer you the full experience.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState,mapActions,mapGetters} from 'vuex';
    import moment from 'moment'

    export default {
        name: 'friendly-popup',

        computed: {
            //mapState can be used to quickly get values from the state
            ...mapState('cookiepopup',
                ['showPopup',
                    'activeTheme',]
            ),

            cookieName: function() {
                return this.$options.name;
            },
        },

        methods: {
            togglePopup() {
                this.$store.commit('cookiepopup/togglePopup');
            }
        }
    }
</script>

<style lang="scss">
    .friendly-popup-bg {
        transition: background 0.3s ease-in-out;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 9999;
        top: 0;
        bottom: -100px;
        background: rgba(0, 0, 0, 0.5);

        .friendly-popup-wrapper {
            position: fixed;
            width: 400px;
            border-radius: 3px;
            left: 0;
            right: 0;
            margin: auto;
            top: 100px;
            opacity: 1;
            text-align: center;
            overflow: hidden;
            background: repeating-linear-gradient(135deg,#cecece,#cecece 7px,#e0e0e0 0,#e0e0e0 14px);

            .popup-top {
                padding: 25px;
                position: relative;
                background: #e8e8e8;
                border-bottom: 2px solid gainsboro;

                h3 {
                    font-size: 18px;
                    line-height: 23px;
                    font-weight: 600;
                    color: #5f5f5f;
                }

                p {
                    margin-top: 15px;
                    line-height: 18px;
                    color: #656565;
                    font-size: 12px;
                }
            }

            .popup-content {
                padding: 25px;
                background: rgba(255, 255, 255, 0.75);

                .popup-button {
                    position: relative;
                    border-radius: 3px;
                    padding: 12px;
                    margin-bottom: 4px;
                    transition: transform 0.2s ease-in-out;

                    span {
                        position: absolute;
                        top: -6px;
                        left: -5px;
                        width: calc(100% + 10px);
                        height: calc(100% + 15px);
                        border: 2px solid #94e4736b;
                        border-radius: 3px;
                    }

                    i {
                        position: absolute;
                        left: 15px;
                        top: calc(50% - 12px);
                        font-size: 24px;
                    }

                    h4 {
                        padding-bottom: 5px;
                        font-size: 15px;
                        font-weight: 600;
                        display: inline-block;
                    }

                    p {
                        opacity: 0.9;
                        font-size: 11px;
                    }

                    .info-box {
                        display: none;
                        position: absolute;
                        bottom: 80px;
                        width: 350px;
                        background: white;
                        border-radius: 10px;
                        left: 50%;
                        transform: translate(-50%);
                        filter: drop-shadow(0px 3px 6px #c3c3c3);
                        padding: 15px;

                        p {
                            opacity: 1;
                            margin: 0;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            width: 0;
                            height: 0;
                            border-left: 15px solid transparent;
                            border-right: 15px solid transparent;
                            border-top: 15px solid #fff;
                            right: 0;
                            left: 0;
                            margin: auto;
                            bottom: -10px;
                        }
                    }

                    &.gray-button {
                        transform: scale(0.95);
                        background: #efefef;
                        color: #888888;
                        border-bottom: 3px solid #c7c7c7;

                        p {
                            opacity: 0.8;
                        }

                        i {
                            opacity: 0.6;
                        }

                        &:hover {
                            transform: scale(1) !important;
                        }
                    }

                    &.orange-button {
                        transform: scale(0.95);
                        background: #efb55e;
                        border-bottom: 3px solid #b78a47;
                        color: #ffffff;

                        &:hover {
                            transform: scale(1) !important;
                        }
                    }

                    &.green-button {
                        background: #6caf51;
                        border-bottom: 3px solid #497736;
                        color: #fff;
                        margin-top: 10px;
                        margin-bottom: 0;
                    }

                    &:hover {
                        transform: scale(1.02);

                        .info-box {
                            display: block;

                            p {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }
</style>